import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class ExamRestraints extends AdminOnlyItemRestraints {
  canToggleItem(item) {
    return 'Prüfungen können nicht deaktiviert werden!';
    // return this.requireRole('ADMINISTRATOR')
  }
}